import React, {useEffect, useRef} from 'react'
import { Helmet } from 'react-helmet'
import LWCLayout from '../../../layouts/LWCLayout'
import CommunityEventList from '../../../components/community/CommunityEventList'

const Past = () => {

    

    const breadcrumbRef = useRef()

    const breadcrumbsItems = [
        {
          href: '/community/conferences',
          label: 'Conferences',
          overflow: false,
          width: 1
        },
        {
          href: '',
          label: 'Past Conferences',
          overflow: false,
          width: 1
        }
      ]

    useEffect(() => {
        customElements.whenDefined("tds-breadcrumbs").then(() => {
          breadcrumbRef.current.items = breadcrumbsItems
        })
    }, [])

    return (
        <LWCLayout>
            <Helmet>
                <title>Community Conferences</title>
            </Helmet>
            <div class="community-past">
                <tm-page class="theme--salesforce community-home" style={{display: 'block', transition: 'opacity 1000ms ease 0s', opacity: 1}}>
                    <tm-section-a
                        title="Past Conferences">
                            <tds-breadcrumbs ref={breadcrumbRef}></tds-breadcrumbs>
                            <CommunityEventList section="past-all" />

                    </tm-section-a>
                </tm-page>
                <th-element-loader element="tm-page" style={{height: '100vh'}}></th-element-loader>
            </div>
        </LWCLayout>
    )
}

export default Past
